// extracted by mini-css-extract-plugin
module.exports = {"message":"CheckoutCustomFields_message__MXagJ"};